import { useState } from "react";
import { Link, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IntroductionDialog } from "./IntroductionDialog";
import { useWasIntroTriggered } from "hooks/introductionHooks";

export function IntroductionButton() {
  const { t } = useTranslation();
  const { wasIntroTriggered, setWasIntroTriggered } = useWasIntroTriggered();
  const [isDialogOpen, setIsDialogOpen] = useState(
    wasIntroTriggered === false ? true : false
  );

  function onCloseDialog() {
    setIsDialogOpen(false);
    setWasIntroTriggered();
  }
  return (
    <>
      <StyledLink
        color="primary"
        className="how-to-link"
        onClick={() => setIsDialogOpen(true)}
      >
        {t("label.exampleProjects")}
      </StyledLink>
      <IntroductionDialog
        isDialogOpen={isDialogOpen}
        onCloseDialog={onCloseDialog}
      />
    </>
  );
}

const StyledLink = styled(Link)`
  font-weight: 700;
  font-size: 14px;
  margin-right: ${({ theme }) => theme.spacing(2)};
`;
